/**
 * Created by nijin on 21/3/17.
 */
import {Directive, ElementRef, Input} from '@angular/core';
import {Md5} from 'ts-md5/dist/md5';
@Directive({
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
  selector: '[toggle-btn]'
})
export class ToggleButton{
  private isOpen = false;
  constructor(private _eref:ElementRef){

  }
  onDocumentClick(event){
    if (!this._eref.nativeElement.contains(event.target))
      this.isOpen = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/site/home/toggle.directive.ts